import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69f8e81cf6558f00145ee959_1782567517070_b3af654d/themasonicvault/src/app/search/page.tsx");
